import styled from 'styled-components'

import { palette } from '../../theme/palette'

export const ModalBody = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999;
`

export const ModalChildrenContainer = styled.dialog`
  border-radius: 10px;
  background: ${palette.white};
  position: relative;
  width: 100%;
  display: block;
  padding: 0;
  border: none;
`
